import template from './prems-discount-promotion-selector.html.twig';

const { Component, Context } = Shopware;
const { EntityCollection, Criteria } = Shopware.Data;

Component.register('prems-discount-promotion-selector', {
    template,
    inheritAttrs: false,

    inject: ['repositoryFactory'],

    props: {
        discountCategory: {
            type: Object,
            required: false,
            default: null
        },
    },
    computed: {
        promotionRepository() {
            return this.repositoryFactory.create('promotion');
        },
        promotionIds: {
            get() {
                this.ensureValueExist();
                return Object.keys(this.discountCategory.discountPromotionIds).length > 0 ?  this.discountCategory.discountPromotionIds : [];
            },
            set(promotionIds) {
                this.ensureValueExist();
                this.discountCategory.discountPromotionIds = promotionIds;
            }
        },
    },

    created() {
        this.createdComponent();
    },

    data() {
        return {
            promotions: null
        };
    },

    methods: {
        createdComponent() {
            this.promotions = new EntityCollection(
                this.promotionRepository.route,
                this.promotionRepository.entityName,
                Context.api
            );

            if (!this.promotionIds || this.promotionIds.length <= 0) {
                return Promise.resolve();
            }

            const criteria = new Criteria();
            criteria.setIds(this.promotionIds);

            return this.promotionRepository.search(criteria, Context.api).then((promotions) => {
                this.promotions = promotions;
            });
        },
        ensureValueExist() {
            if (typeof this.discountCategory.discountPromotionIds === 'undefined' || this.discountCategory.discountPromotionIds === null) {
                this.discountCategory.discountPromotionIds = {};
            }
        },
        setPromotionIds(promotions) {
            this.promotionIds = promotions.getIds();
            this.promotions = promotions;
        }
    }
});
